import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface DemoRequestResponse {
    id: number;
    fullName: string;
    corporateEmail: string;
    phone: string;
    companyName: string;
    jobTitle: string;
    industry: string;
    companySize: string;
    monthlyCustomerQueries: string;
    additionalComments: string;
    requestDate: string;
    status: boolean;
}

export interface DemoRequestApiResponse {
    statusCode: number;
    message: string;
    page: number;
    pageSize: number;
    totalRecords: number;
    data: DemoRequestResponse[];
}

export const getDemoRequest = async (
    startDate: string,
    endDate: string,
    page: number = 1,
    pageSize: number = 10
): Promise<DemoRequestApiResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}demo-request/get-request?startDate=${startDate}&endDate=${endDate}&page=${page}&pageSize=${pageSize}`;

        const token = localStorage.getItem('token');
        if (!token) throw new Error('Token no disponible');

        const response = await axios.get(endpoint, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.statusCode !== 200) {
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error) {
        console.error('Error fetching demo request:', error);
        throw error;
    }
};

